/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_NavigationInputs */

const en_options_navigation = /** @type {(inputs: Options_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options navigation`)
};

const fr_options_navigation = /** @type {(inputs: Options_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation des options`)
};

const de_options_navigation = /** @type {(inputs: Options_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionen-Navigation`)
};

const it_options_navigation = /** @type {(inputs: Options_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di navigazione`)
};

const ru_options_navigation = /** @type {(inputs: Options_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры навигации`)
};

const es_options_navigation = /** @type {(inputs: Options_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de navegación`)
};

const zh_cn2_options_navigation = /** @type {(inputs: Options_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选项导航`)
};

const ja_options_navigation = /** @type {(inputs: Options_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オプションナビゲーション`)
};

const hi_options_navigation = /** @type {(inputs: Options_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विकल्प नेविगेशन`)
};

const pt_pt2_options_navigation = /** @type {(inputs: Options_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegação de opções`)
};

/**
* | output |
* | --- |
* | "Options navigation" |
*
* @param {Options_NavigationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_navigation = /** @type {((inputs?: Options_NavigationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_NavigationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_navigation(inputs)
	if (locale === "de") return de_options_navigation(inputs)
	if (locale === "it") return it_options_navigation(inputs)
	if (locale === "ru") return ru_options_navigation(inputs)
	if (locale === "es") return es_options_navigation(inputs)
	if (locale === "zh-CN") return zh_cn2_options_navigation(inputs)
	if (locale === "ja") return ja_options_navigation(inputs)
	if (locale === "hi") return hi_options_navigation(inputs)
	if (locale === "pt-PT") return pt_pt2_options_navigation(inputs)
	return en_options_navigation(inputs)
});